export class ObjectUtils {
    // @ts-ignore
  public static getKeyValue<T, string>(obj: T, key: string): T[string] {
      // @ts-ignore
    return obj[key];
    }

    public static capitalize(obj: any): object {
        Object.keys(obj)
            .filter(o => typeof obj[o] === 'string' || typeof obj[o] === 'object')
            .forEach(o => {
                if ((obj[o] === undefined || obj[o] === null)) {
                    return;
                }
                if (typeof obj[o] === 'string') {
                    if (!(obj[o] as string).includes('data:image') && !(obj[o] as string).includes('https://')) {
                        obj[o] = (obj[o] as string).toUpperCase();
                    }
                } else {
                    obj[o] = ObjectUtils.capitalize(obj[o]);
                }
            });
        return obj;
    }

    public static flatten(arr: []): any[] {
        return arr.reduce((flat, toFlatten) => {
          const array = Array.isArray(toFlatten) ? ObjectUtils.flatten(toFlatten) : toFlatten;
            return flat.concat(array as never[]);
        }, []);
    }
}

export interface Dictionary<T> {
  [Key: string]: T;
}
